'use strict';

var Hounisen = Hounisen || {};
Hounisen.productfacets = new function () {

    function init() {
        ProductFacets();
    }

    function ProductFacets() {
        document.addEventListener("DOMContentLoaded", function () {
            // Get current parameters
            var currentParameters = new URLSearchParams(window.location.search);
            var manufactureridSelect = document.getElementById("ManufacturerID");
            var sortSelect = document.getElementById("sort-facet-input");
            var inStockInput = document.getElementById("in-stock-input");

            function ResetPageNumber() {
                currentParameters.set("PageNum", "1");
            }

            function UpdateParameters() {

                // Update manufacturer if it is changed
                if (manufactureridSelect) {

                    var selectedValue = manufactureridSelect.options[manufactureridSelect.selectedIndex].value;
                    currentParameters.set("ManufacturerID", selectedValue);

                }

                // Update stock if it is changed
                if (inStockInput) {
                    var inStockValue = inStockInput.checked ? "1" : "";
                    currentParameters.set("MinStockAmount", inStockValue);
                }

                ResetPageNumber();
                window.location.search = currentParameters.toString();

            }

            function UpdateSortParameter() {
                // Always update sorting parameter regardless of other conditions
                if (sortSelect) {
                    var selectedValue = sortSelect.value;

                        currentParameters.set("SortBy", selectedValue);
                        ResetPageNumber();
                        window.location.search = currentParameters.toString();
                }
            }

            function ChangeListener() {
                const elements = [
                    { element: manufactureridSelect, event: "change" },
                    { element: sortSelect, event: "change" },
                    { element: inStockInput, event: "change" }
                ];

                elements.forEach(function (item) {
                    if (item.element) {
                        if (item.element === sortSelect) {
                            item.element.addEventListener(item.event, UpdateSortParameter);
                        } else {
                            item.element.addEventListener(item.event, UpdateParameters);
                        }
                    }
                });
            }

            ChangeListener();
        });
    }

    return {
        init: init,
    };
}

();
